class DeliverySaverSubscriptionDetailController {
    $onInit() {
        this.isAnnualPlan = this.plan && this.plan.BillingFrequencyMonths === 12;
        this.periodEndDate = this.subscription && new Date(this.subscription.NextBillingDate);
        this.periodEndDate = this.periodEndDate && this.periodEndDate.setDate(this.periodEndDate.getDate() - 1);
    }
}

const DeliverySaverSubscriptionDetailComponentDefinition = {
    controller: DeliverySaverSubscriptionDetailController,
    template: require('./delivery-saver-subscription-detail.component.html').trim(),
    bindings: {
        plan: '<',
        subscription: '<',
        shortTitle: '<',
    },
};

module.exports = {
    DeliverySaverSubscriptionDetailController,
    DeliverySaverSubscriptionDetailComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/subscriptiondetail/delivery-saver-subscription-detail.component.js